import cx from "classnames";
import Item from "./Item";
import styles from "./Experiences.module.scss";
import Swiper from "@components/Swiper";
import Icons from "@gstyles/styleguide/icons";
import useSwiper from "@hooks/useSwiper";
import { usePageContext } from "@providers/PageProvider";
import { dinningPage } from "@utils/helper";
import _ from "lodash";

export default function Experiences() {
  const { pageData } = usePageContext();
  const experience = dinningPage.formatExperience(pageData);
  const isAuto = _.get(experience, "slider.isAuto");
  const interval = _.get(experience, "slider.interval");
  const slides = _.get(experience, "slider.slides");
  useSwiper(".swiper-dinning-experiencing", {
    rewind: true,
    spaceBetween: 32,
    speed: 1000,
    autoplay: !!isAuto && {
      delay: interval,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      1280: {
        slidesPerView: "auto",
      },
    },
    navigation: {
      nextEl: ".swiper-arrow-next-dinning-experiencing",
      prevEl: ".swiper-arrow-prev-dinning-experiencing",
    },
  });
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.titleSection)}>
        {_.get(experience, "title")}
      </div>
      <div className={cx(styles.swiperWrapper)}>
        <Icons
          name="chevron-left-outline"
          color="#F7EEDF"
          className={cx(
            "swiper-arrow-prev-dinning-experiencing",
            styles.prevArrowIconMb
          )}
        />
        <Swiper className={cx("swiper-dinning-experiencing", styles.swiper)}>
          {_.map(slides, (item: any, index) => {
            return (
              <Item
                className="swiper-slide"
                data={{
                  title: _.get(item, "title"),
                  content: _.get(item, "description"),
                  button: _.get(item, "button"),
                  image: _.get(item, "image"),
                }}
                key={`slide_${""}_${index}`}
              />
            );
          })}
        </Swiper>
        <Icons
          name="chevron-right-outline"
          color="#F7EEDF"
          className={cx(
            "swiper-arrow-next-dinning-experiencing",
            styles.nextArrowIconMb
          )}
        />
      </div>
      {/* <div className={cx("flex justify-center mt-8")}>
        <Button className={cx(styles.exploreBtn)} label="Explore more" />
      </div> */}
    </div>
  );
}
